import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import axios from 'axios'
import { API_SETTING_URL } from '@/.env'
import localStorageKey from '@/constants/localStorageKey'
import { getItemByLocalStorage } from '@/utils/localStorage'

export default class CurrencyService extends BaseService {
  static async getCurrencyRates () {
    try {
      const response = await axios.get(`${API_SETTING_URL}/v0/stores/${getItemByLocalStorage(localStorageKey.STORE_ID)}/currency-rates?storeId=${getItemByLocalStorage(localStorageKey.STORE_EXTERNAL_ID)}&page=1&limit=100`)
      if (response.data.items) {
        const data = response.data.items
        return new ResponseWrapper(response, data)
      }
    } catch (error) {
      throw new ErrorWrapper(error, error.message)
    }
  }

  static async getCurrencyRatesAllStore (storeIds) {
    try {
      const response = await axios.get(`${API_SETTING_URL}/v0/currency-rates?storeIds=${storeIds}&page=1&limit=100`)
      if (response.data.items) {
        const data = response.data.items
        return new ResponseWrapper(response, data)
      }
    } catch (error) {
      throw new ErrorWrapper(error, error.message)
    }
  }

  static async getCurrencies () {
    try {
      const response = await axios.get(`${API_SETTING_URL}/v0/stores/${getItemByLocalStorage(localStorageKey.STORE_ID)}/currencies?storeId=${getItemByLocalStorage(localStorageKey.STORE_EXTERNAL_ID)}&page=1&limit=100`)
      if (response.data.items) {
        const data = response.data.items
        return new ResponseWrapper(response, data)
      }
    } catch (error) {
      throw new ErrorWrapper(error, error.message)
    }
  }
}
